var map = {
	"./en-US.json": "./src/translations/src/locales/en-US.json",
	"./es-US.json": "./src/translations/src/locales/es-US.json",
	"./fr-CA.json": "./src/translations/src/locales/fr-CA.json",
	"./zh-Hans.json": "./src/translations/src/locales/zh-Hans.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/translations/src/locales sync recursive ^\\.\\/.*\\.json$";